<template>
    <div class="panel panel-default panel-dashboard">
        <div class="panel-body" :class="{'meeting-legend-limited': collapsed}">
            <dl>
                <dt>
                    General
                </dt>

                <dd>
                    The number of opportunities are always shown as the number of closed opportunities and the total
                    number of opportunities.
                </dd>

                <br>

                <dt>
                    Open
                </dt>

                <dd>
                    An opportunity is considered open when it has not been closed.
                </dd>

                <br>

                <dt>
                    Missed And Converted
                </dt>

                <dd>
                    An opportunity is considered missed when it has been closed and no associated order or subscription
                    exists. An opportunity is considered converted when it has been closed and an associated order or
                    subscription exists. Together, missed and converted opportunities are called closed opportunities.
                </dd>

                <br>

                <dt>
                    Conversion Rate
                </dt>

                <dd>
                    The conversion rate is calculated as the number of converted opportunities divided by the number of
                    closed opportunities.
                </dd>

                <br>

                <dt>
                    Total Value
                </dt>

                <dd>
                    The total value is the estimated value of all opportunities that match the filters.
                </dd>

                <br>

                <dt>
                    Open Value
                </dt>

                <dd>
                    The open value is the estimated value of all open opportunities that match the filters.
                </dd>

                <br>

                <dt>
                    Closed Value
                </dt>

                <dd>
                    The closed value is the estimated value of all closed opportunities that match the filters.
                </dd>

                <br>

                <dt>
                    Missed Value
                </dt>

                <dd>
                    The missed value is the estimated value of all missed opportunities that match the filters.
                </dd>

                <br>

                <dt>
                    Converted Value
                </dt>

                <dd>
                    The converted value is the estimated value of all converted opportunities that match the filters.
                </dd>

                <br>

                <dt>
                    Actual Value
                </dt>

                <dd>
                    The actual value is the value of all orders and subscription periods that are associated with
                    opportunities that match the filters. For subscription periods, only the first subscription period
                    in a subscription counts.
                </dd>
            </dl>

            <div class="meeting-legend-show-more" :class="{'meeting-legend-show-more--collapsed': collapsed}">
                <button type="button" class="btn btn-xs btn-black" @click="collapsed = !collapsed">
                    <i class="fa fa-search"/> {{ collapsed ? 'Expand' : 'Collapse'}}
                </button>
            </div>
        </div>
    </div>
</template>

<style>
    .meeting-legend-limited {
        height: 200px;
        overflow: hidden;
        position: relative;
    }

    .meeting-legend-show-more {
        text-align: center;
        width: 100%;
    }

    .meeting-legend-show-more--collapsed {
        background-image: linear-gradient(to bottom, transparent, white);
        position: absolute;
        bottom: 0;
        left: 0;
        padding: 20px;
    }
</style>

<script>
    export default {
        data() {
            return {
                collapsed: true
            }
        }
    }
</script>
